import { createUseStyles } from "react-jss";
import userpng from "../../assets/user.png";
import styleVariables from "../../style_setup";

const styles = createUseStyles({
  DropDownProfileOption: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 .25rem",
  },
  avatar: {
    width: "2rem",
    height: "2rem",
    objectFit: "cover",
    borderRadius: "50%",
  },
  [`@media ${styleVariables.media.smallscreen}`]: {},
});

export const DropDownProfileOption = () => {
  const classes = styles({});

  return (
    <div className={classes.DropDownProfileOption}>
      <img src={userpng} alt="" className={classes.avatar} />
    </div>
  );
};
